export { default } from "./ClickEventCapturer";
